<template>
    <v-container class="pa-0" fluid>
        <v-layout row wrap>
            <v-flex class="hide-on-xs pa-0" md8 xs12>
                <slider :type="'Embassy'"></slider>
            </v-flex>
            <v-flex md4 xs12>
                <v-card class="full-height d-flex">
                    <v-card-text class="d-flex flex-column">
                        <div>
                            <div class="layout column align-center">
                                <img alt="Logo Here" src="../../public/static/logo.png" width="90%"/>
                            </div>
                            <div class="mt-2 mb-4 justify-center" style="display: flex;">
                                <div class="app-name-panel">Online Visa Application
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on"
                                                   color="primary" text @click="showManual">User Manual <v-icon>mdi-file-pdf</v-icon></v-btn>

                                        </template>
                                        <span>User Manual of Visa Applying Process</span>
                                    </v-tooltip></div>
                            </div>

                            <v-form class="px-4" lazy-validation ref="form" v-model="valid">
                                <v-layout column wrap>
                                    <form-error-display-handler :errors="errors"></form-error-display-handler>
                                    <v-flex md12 xs12>
                                        <v-autocomplete
                                                :items="sortedArray"
                                                :label="$vuetify.lang.t('$vuetify.select_embassy') +' *'"
                                                :rules="[rules.required]"
                                                item-text="name"
                                                item-value="slug"
                                                @change="selectEmbassy($event)"
                                                outlined
                                                id="select_embassy"
                                                v-model="visa.office"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex md12 xs12>
                                        <v-autocomplete
                                                :clearable="true"
                                                :items="countries"
                                                label="Select your nationality *"
                                                :rules="[rules.required]"
                                                item-text="nationality"
                                                item-value="id"
                                                outlined
                                                v-model="visa.last_arriving_country"
                                                id="selectCountry"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex md4 xs12>
                                        <v-select
                                                :clearable="true"
                                                :items="visaTypes"
                                                :label="$vuetify.lang.t('$vuetify.select_visa_type')+' *'"
                                                :rules="[rules.required]"
                                                item-text="type"
                                                item-value="slug"
                                                outlined
                                                v-model="visaType.slug"
                                                id="selectVisa"
                                                @change="visaChoosed"
                                        ></v-select>
                                    </v-flex>


                                    <v-layout class="mx-0" md12 row wrap>
                                        <v-flex sm12>
                                            <v-text-field
                                                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-2': $vuetify.breakpoint.mdAndUp}"
                                                    :clearable="true"
                                                    :label="$vuetify.lang.t('$vuetify.passport_number')+' *'"
                                                    :rules="[rules.required]"
                                                    outlined
                                                    v-model="visa.passport.passport_number"
                                            />
                                        </v-flex>
                                        <v-flex sm12 mb-2 mx-3>
                                            <date-picker-new
                                                    label="Date of Birth"
                                                    v-model="visa.traveller.dob"
                                                    :min-year="dateOfBirth.min_year"
                                                    :max-year="dateOfBirth.max_year">
                                            </date-picker-new>
                                        </v-flex>
                                        <v-flex sm12 mx-3>
                                            <v-checkbox
                                                    :label="'I have already travelled Nepal this year ('+dateOfBirth.max_year+')'"
                                                    v-model="visa.traveller.not_first_time">
                                            </v-checkbox>
                                        </v-flex>
                                    </v-layout>

                                    <v-flex class=" mb-7" md4 xs12>
                                        <v-btn
                                                :loading="visaLoading"
                                                @click="visaSelect"
                                                block
                                                color="primary"
                                                large
                                        >{{ $vuetify.lang.t('$vuetify.proceed') }}
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </div>
                        <v-spacer/>
                        <div>
                            <v-layout wrap>
                                <v-flex class="row justify-center" xs12>
                                    <h5 class="text--darken-1">Developed by &nbsp;</h5>
                                    <img alt="Logo Here" height="20px" src="/static/nepal_sarkar.png" width="24px"/>
                                    <h4 style="color: black;margin-left: 2px;">Department of Immigration, Nepal</h4>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import Http from "axios";
    import {API_URL, VERSION,} from "../config/config";
    import Slider from "./Slider";
    import FormErrorDisplayHandler from "../components/FormErrorDisplayHandler";
    import DatePickerNew from "../components/DatePickerNew";

    export default {
        components: {
            Slider, FormErrorDisplayHandler, DatePickerNew
        },
        data() {
            return {
                background: require("@/assets/background.jpg"),
                stepper: 0,
                loading: false,
                selected: null,
                selectedEmb: null,
                nationalitySelected: null,
                visaSelected: "tourist-visa",
                valid: false,
                sliders: [],
                sliderLoaded: false,
                rules: {
                    required: value => !!value || "Required."
                    // fromSameEmbassy: value => value && value === this.embassyOffice.country_id || "Cannot apply for other country"
                },
                languages: [
                    {
                        text: "English",
                        value: "en"
                    },
                    {
                        text: "Chinese",
                        value: "cn"
                    }
                ],
                visa_number: "1234567891",
                passport_number: "",
                dob: "",
                errors: [],
            };
        },
        //
        computed: {
            ...mapGetters({
                nationalityLoading: "CountryForTouristList/loading",
                visaLoading: "VisaType/loading",
                visa_types: "VisaType/visa_types",
                allTouristCountries: "CountryForTouristList/all",
                office: "VisaSingle/office",
                apply_type: "VisaSingle/apply_type",
                embassyOffices: "Office/embassyOffices"
            }),

            countries() {
                return this.allTouristCountries.filter(i => (i.code !== "NPL" && i.code !== "IND"));
            },
            visaTypes() {
                let visaTypes = this.visa_types;
                // if (this.$route.name === 'OnlineApplication')
                //     visaTypes = visaTypes.filter(el => el.slug !== 'transit-visa');
                return visaTypes;
            },

            sortedArray() {
                let sortedOffices = this.embassyOffices;
                return sortedOffices.sort((a, b) => a.name.localeCompare(b.name));
            },

            visas() {
                return this.$store.state.VisaTypeList.all;
            },

            visa() {
                let v = this.$store.state.VisaSingle.visa;
                return v;
            },

            visaType() {
                let vt = this.$store.state.VisaType.visa_type;
                return vt;
            },
            // embassyName(){
            //      return this.embassyOffice.name?this.embassyOffice.name.toUpperCase():'No Embassy Found';
            // }

            dateOfBirth() {
                const max_year = parseInt(new Date().toISOString().substr(0, 4));
                const min_year = parseInt(max_year) - 120;
                return {
                    min_year,
                    max_year
                }
            },
        },
        methods: {
            ...mapActions({
                fetchAllNationalities: "CountryForTouristList/fetchAll",
                searchForTraveller: "VisaSingle/searchForTravellerIfAny",
                fetchEmbassyoffice: "Office/fetchEmbassyoffices",
                fetchOfficeRate: "Office/fetchOfficeRate"
            }),
            searchTraveller() {
                if (this.$refs.form.validate() && this.validateDob()) {
                    this.searchForTraveller({
                        dob: this.visa.traveller.dob,
                        passport_number: this.visa.passport.passport_number,
                        office: this.selectedEmb,
                        country: this.visa.last_arriving_country,
                    })
                        .then(() => {
                            this.$router.push({
                                name: "VisaApplication",
                                params: {
                                    type: this.visaSelected,
                                    office: this.selectedEmb,
                                    apply: this.apply_type,
                                    // dob: this.dob,
                                    // passport_number: this.passport_number,
                                }
                            })
                        })
                        .catch((err) => {
                            this.$router.push({
                                name: "VisaApplication",
                                params: {
                                    type: this.visaSelected,
                                    office: this.selectedEmb,
                                    apply: this.apply_type,
                                    // dob: this.dob,
                                    // passport_number: this.passport_number,
                                }
                            })
                        })
                }
            },

            validateDob() {
                let date1 = Date.parse(this.visa.traveller.dob);
                let date2 = Date.now();
                if (date1 > date2) {
                    this.$store.commit('Notification/showError', 'Invalid Date of Birth. DOB cannot be future dates')
                    return false;
                }
                return true
            },
            visaSelect() {
                if (this.$refs.form.validate()) {
                    let nationality = this.countries.find(
                        n => n.id === this.visa.last_arriving_country
                    );
                    let visa_selected = this.visa_types.find(
                        n => n.slug === this.visaType.slug
                    );
                    this.selectedEmb = this.visa.office;
                    let office = this.embassyOffices.find(n => n.slug === this.selectedEmb);
                    this.$store.commit("CountryForTouristList/setCurrent", nationality);
                    this.$store.commit("VisaType/setVisaType", visa_selected);
                    this.$store.commit("VisaSingle/setOffice", office);
                    // this.$store.commit("VisaSingle/setLastArrivalCountry", this.nationalitySelected);
                    // this.$store.commit('VisaSingle/setPassportNumber', this.passport_number);
                    // this.$store.commit('VisaSingle/setDOB', this.dob);
                    this.fetchOfficeRate(office.id);
                    this.searchTraveller();
                }
            },
            select(event) {
                this.selected = event;
                this.$vuetify.lang.current = "" + event;
            },
            selectEmbassy(event) {
                console.log(event);
            },
            showManual() {
                window.open(this.pdf_url, "_blank")
            },
            visaChoosed() {
                this.visaSelected = this.visaType.slug;
            }
        },
        mounted() {
            // this.$store.commit("VisaSingle/resetState");
            this.fetchEmbassyoffice();
            // this.nationalitySelected = this.embassyOffice.country_id;
            this.select(this.languages[0].value);
            this.fetchAllNationalities();
            this.$store.commit("VisaType/setArrivalVisaTypes")
            Http.get(`${API_URL}${VERSION}/user-manual`).then((res) => {this.pdf_url = res.data.data})
        }
    };
</script>
<style lang="css">
    .align-center {
        text-align: center;
    }
</style>
